import Swiper, { Keyboard, Navigation, Autoplay, EffectFade } from 'swiper';
import SwiperCore from 'swiper';

export function secondProjectsSlider() {
  const $slider = $('.second-projects-slider');
  if (!$slider || $slider.length === 0) return;

  SwiperCore.use([Navigation, Keyboard, Autoplay, EffectFade]);

    const swiper = new Swiper('.second-projects-slider', {
        slidesPerView: 1,
        speed: 800,

        navigation: {
            nextEl: '.second-projects-next',
            prevEl: '.second-projects-prev',
        },

        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },

        loop: true,

        roundLengths: true,

        observer: true,
        observeParents: true,

        watchSlidesProgress: true,
    });
}